import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PAYMENT_METHOD_TYPE } from '@src/constants/payment';
import iconPaymentMethodGg from '@src/assets/icons/payment-method-gg.svg';
import iconPaymentMethodApple from '@src/assets/icons/payment-method-apple.svg';
import iconMasterCard from '@src/assets/icons/master-card.png';

const PaymentMethod = ({ paymentMethodType }) => {
  const { t } = useTranslation();

  const renderPaymentMethodIcon = () => {
    if (paymentMethodType === PAYMENT_METHOD_TYPE.APPLE)
      return <img src={iconPaymentMethodApple} alt="Apple Pay" />;

    if (paymentMethodType === PAYMENT_METHOD_TYPE.GOOGLE)
      return <img src={iconPaymentMethodGg} alt="Google Play" />;

    return <img src={iconMasterCard} alt="Master Card" />;
  };

  return (
    <Box className="content-item">
      <Typography className="label">{t('newPaymentMethod')}</Typography>
      <Typography className="content">{renderPaymentMethodIcon()}</Typography>
    </Box>
  );
};

export default PaymentMethod;
